module.exports = __webpack_public_path__ + "img/asesoria-legal.d522a2bb.png";